import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import {
  makeStyles,
  Box,
  Typography,
  MenuItem,
  Select,
} from "@material-ui/core";
import colors from "../constants/colors";
import { store } from "../store";
import { drivers } from "../constants/mocks";

const DriverSelect: FC = observer(() => {
  const classes = styles();
  const { driverName, throatExit } = store;
  const handleChange = (event) => {
    store.driverName = event.target.value;
  };

  const filteredDrivers = drivers.filter(
    (driver) => driver["Throat Exit"] === throatExit
  );

  return (
    <Box className={classes.container}>
      <Typography className={classes.parameterText}>Driver</Typography>
      <Select
        className={classes.select}
        value={driverName}
        onChange={handleChange}
      >
        {filteredDrivers.map(({ "Driver Name": name }) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  parameterText: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 12,
    letterSpacing: 1.5,
    color: colors.dark,
    maxWidth: 100,
  },
  select: {
    margin: "0px 20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
}));

export default DriverSelect;
